/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useState, useEffect } from 'react';

const CycleMarker = (props: any) => {
    const {handleClick, serverStatus } = props;
    const [color, setColor] = useState('success');

    useEffect(() => {
        switch (serverStatus) {
            case 1:
                setColor('success');
                break;
            case 2:
                setColor('warning')
                break;
            case 3:
                setColor('danger')
                break;

            default:
                break;
        }
    }, [serverStatus])

    return (
        <td style={{ padding: '0px 10px', overflow: 'hidden', height: 40,   }}
            onClick={handleClick}
        >
            <div className={`bg-${color}`} style={{borderRadius: '100%', width: '20px', height: '20px'}}>

            </div>
        </td>
    )
}

export default CycleMarker;